import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import BasicForm from './Forms/BasicForm';
import { useState } from 'react';
import { useEffect } from 'react';
import DocumentForm from './Forms/DocumentForm';
import ImageModel from './Forms/ImageModel';
// import Typography from '@mui/material/Typography';

const steps = ['Basic Details', 'Documents'];

export default function VendorStepForm() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [PostData, setPostData] = useState({});
  const [IsPanVerified, setIsPanVerified] = useState(false);
  const [IsBankVerified, setIsBankVerified] = useState(false);
  const [FileData, setFileData] = useState(null);
  const [Open, setOpen] = useState(false);
  const [Image, setImage] = useState(null);
  const [fileType, setFileType] = useState('');

  const handleNext = (postdata) => {
    setActiveStep(activeStep + 1);
    setPostData({ ...PostData, ...postdata });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    console.log('hit');

    setActiveStep(step);
  };

  useEffect(() => {
    console.log('PostData', PostData);
  }, [PostData]);

  const handleImageOpen = (image) => {
    if (image) {
      setImage(URL.createObjectURL(image));

      setOpen(true);
      if (image.type === 'application/pdf') {
        setFileType('pdf');
      } else if (image.type.startsWith('image/')) {
        setFileType('image');
      } else {
        setFileType('');
        alert('Please upload an image or PDF file.');
      }
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <h3>Supplier / Vendor</h3>
      <ImageModel open={Open} image={Image} handleClose={() => setOpen(false)} fileType={fileType} />
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton color="secondary" onClick={handleStep(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div>
        {
          <React.Fragment>
            {activeStep === 0 ? (
              <BasicForm
                handleNext={handleNext}
                setPostData={setPostData}
                PostData={PostData}
                IsBankVerified={IsBankVerified}
                setIsBankVerified={setIsBankVerified}
                IsPanVerified={IsPanVerified}
                setIsPanVerified={setIsPanVerified}
              />
            ) : activeStep === 1 ? (
              <DocumentForm
                handleBack={handleBack}
                postData={PostData}
                data={FileData}
                setFileData={setFileData}
                handleOpenImage={handleImageOpen}
              />
            ) : null}
          </React.Fragment>
        }
      </div>
    </Box>
  );
}
